import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4a813c40&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4a813c40&prod&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=4a813c40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a813c40",
  null
  
)

export default component.exports